import axios, { AxiosResponse } from 'axios';
import { Auth } from '@/classes/Auth';

import router from '../routes';
import Vue from 'vue';

const auth = new Auth

export const apiv1 = axios.create({
    baseURL: `${process.env.VUE_APP_BACKEND}/api`,
    // timeout: 120000,
    headers: {
        'Content-Type': 'application/json',
        'AUTH_TOKEN': `Bearer ${localStorage.getItem('AUTH_TOKEN') || null}`
    }
})

apiv1.interceptors.request.use(req => {
    const token = localStorage.getItem('AUTH_TOKEN');
    if (!token) {
        logout()
    } else {
        req.headers["AUTH_TOKEN"] = token;
    }
    return req;
})

apiv1.interceptors.response.use(res => {
    return res;
}, error => {
    const { status } = error.response;
    switch (status) {
        // case 401:
        //     break;
        case 500:
            Vue.swal("Error", error.response.data, "error")
            return Promise.reject(error)
        default:
            Vue.swal("Upss!", error.response.data, "warning")
            return Promise.reject(error)
    }
});

function logout() {
    auth.logout();
    // console.clear();s
    router.push('/')
        .catch(err => err)
}